import React, { FC, MouseEvent, useContext, useEffect, useState } from 'react'
import { TNInput } from '../components/TNInput'
import { useDispatch, useSelector } from 'react-redux'
import { AppState, authCheckAccessToken } from '@news-mono/web-common'
import { TNButton } from '../components/TNButton'
import {
    ChangeNameFormData,
    useChangeName,
    validateName,
} from '../hooks/useChangeName'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { UserSettingProps } from '../UserSetting'
import { StyledButtonGroup } from '../MainScreen/MainScreen.styled'

export interface ChangeNameProps extends UserSettingProps {}

export const ChangeName: FC<ChangeNameProps> = ({ onEvent, log, config }) => {
    const dispatch = useDispatch()
    const { setToast, setMessageBanner, goBackToParent } =
        useContext(MyAccountContext)
    const {
        firstName,
        lastName,
        wanUserId: userId,
    } = useSelector((state: AppState) => state.authentication)

    const [submitting, setSubmitting] = useState<boolean>(false)
    const [name, setName] = useState<ChangeNameFormData>({
        firstName: firstName ?? '',
        lastName: lastName ?? '',
    })

    const { mutateAsync: changeName } = useChangeName({
        firstName: name.firstName.trim(),
        lastName: name.lastName.trim(),
        userId,
    })

    async function onChangeSubmit(e: MouseEvent<HTMLElement>) {
        e.preventDefault()
        setMessageBanner(undefined)
        const validate = validateName(name)

        if (!validate.valid) {
            validate.message &&
                setMessageBanner({
                    text: validate.message,
                    type: 'error',
                })
        } else {
            setSubmitting(true)
            const res = await changeName()
            setSubmitting(false)
            if (res) {
                setToast({
                    text: 'Saved',
                    type: 'success',
                    show: true,
                })
                goBackToParent(false)

                // Refresh user info after updates
                dispatch(
                    authCheckAccessToken({
                        onEvent,
                        log,
                        config,
                        invocation: 'auto',
                        forceRefresh: true,
                    }),
                )
            } else {
                setToast({
                    text: 'Failed to save.',
                    type: 'error',
                    show: true,
                })
            }
        }
    }

    function onCancel(e: MouseEvent<HTMLElement>) {
        e.preventDefault()
        goBackToParent(true)
    }

    return (
        <form>
            <TNInput
                id="first-name"
                label="First name"
                value={name.firstName}
                onChange={(firstName) => setName({ ...name, firstName })}
            />
            <TNInput
                id="last-name"
                label="Last name"
                value={name.lastName}
                onChange={(lastName) => setName({ ...name, lastName })}
            />
            <StyledButtonGroup>
                <TNButton onClick={onCancel} btnType="muted">
                    CANCEL
                </TNButton>
                <TNButton
                    onClick={onChangeSubmit}
                    btnType="primary"
                    disabled={submitting}
                >
                    SAVE
                </TNButton>
            </StyledButtonGroup>
        </form>
    )
}
